import React from 'react';
import styles from './ResourceSearchBanner.module.scss';
import Typography from '@mui/material/Typography';
import { ResourceSearch } from 'new/elements/ResourceSearch';
import { ResourceSearchProps } from 'new/elements/ResourceSearch/ResourceSearch';

interface ResourceSearchBannerProps {}

export function ResourceSearchBanner(props: ResourceSearchBannerProps & ResourceSearchProps) {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Typography variant="h1">Want to search for a particular resource?</Typography>
        <Typography variant="body2">
          Please provide the basic information for the resource you want
        </Typography>
        <div className={styles.searchContent}>
          <ResourceSearch {...props} />
        </div>
      </div>
    </div>
  );
}
